export function excludePatchVersions(allVersions: string[]) {
  const versions: string[] = []
  allVersions.forEach((version) => {
    const [major, minor, patch] = version.split(".")
    if (patch !== "0") return // only minor versions should be shown

    const minorVersion = major && minor ? `${major}.${minor}.0` : version

    versions.push(minorVersion)
  })
  return [...new Set(versions)] // remove duplicates
}
